export const TEST_ID = 'calibrationKindSelector';

export const CALIBRATION_KINDS = ['pump', 'flow', 'weight', 'magnetometer', 'level'] as const;
